/**
 * description 机器人稿详情页
 * created by he.zhikai
 * created on 2017-12-15
 */
'use strict';
angular.module('resourceCenterRobotDetailModule', []).controller('resourceCenterRobotDetailCtrl', [
    '$scope',
    '$rootScope',
    '$state',
    '$timeout',
    '$stateParams',
    '$window',
    '$filter',
    'trsHttpService',
    'modalDialog',
    'trsPrintService',
    'resourceCenterService',
    'resCtrModalService',
    'storageListenerService',
    'localStorageService',
    function(
        $scope,
        $rootScope,
        $state,
        $timeout,
        $stateParams,
        $window,
        $filter,
        trsHttpService,
        modalDialog,
        trsPrintService,
        resourceCenterService,
        resCtrModalService,
        storageListenerService,
        localStorageService
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.params = {
                typeid: 'zyzx',
                serviceid: 'robotNews',
                modelid: 'detail',
                nid: $stateParams.guid,
            };
            $scope.status = {
                listOpen: 'processView', // 默认选中的属性信息
                attrDropdown: {
                    groupProcess: true, // 集团取签流程
                    groupEntityInfo: true, // 稿件信息
                },
                hasPicture: false, // 地震稿件是否自带图片
                isTyphoon: false, // 是否为台风稿件
            };
            $scope.data = {
                keywordsArray: [], // 关键词数组
                tenantInfo: '', // 租户信息
                groupProcess: {
                    // 集团取签流程
                    medias: [], // 媒体列表
                    operators: [
                        {
                            // 操作人
                            name: '取稿人',
                            value: 'takeDraft',
                        },
                        {
                            name: '签发人',
                            value: 'issue',
                        },
                        {
                            name: '见报人',
                            value: 'appearNews',
                        },
                        {
                            name: '撤稿人',
                            value: 'withdraw',
                        },
                    ],
                    process: [], // 取签流程
                    selectedMedia: '', // 选中的产品
                },
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            requestData();
            initQqjccInfos();
            headPortrait();
        }

        /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                $scope.detailInfos = data.content[0];
                var date = new Date(Date.parse($scope.detailInfos.updatetime));
                $scope.detailInfos.updatetime = $filter('date')(date, 'yyyy-MM-dd HH:mm:ss').toString();
                $scope.status.hasPicture = !(data.content[0].CONTENT.indexOf('<img src=') > -1);
                if (data.content[0].modName == '地震') {
                    earthquakeChart(data.content[0].nid);
                } else if (data.content[0].modName == '台风新闻') {
                    typhoonChart(data.content[0].nid);
                } else {
                    $scope.status.hasPicture = false;
                }
            });
        }

        /**
         * [earthquakeChart description] 加载地震新闻的图片
         * @param  {[type]} nid [description]
         * @return {[type]}     [description]
         */
        function earthquakeChart(nid) {
            var params = {
                typeid: 'zyzx',
                serviceid: 'robotNews',
                modelid: 'earthquake',
                nid: nid,
            };
            require(['echarts', './lib/echarts/dist/echarts.min', './lib/echarts/dist/china.js'], function(echarts) {
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    if (data == null || data == '') {
                        $scope.status.hasPicture = false;
                        return;
                    }
                    var option = {
                        title: {
                            text: '地震分布',
                        },
                        tooltip: {
                            trigger: 'item',
                        },
                        geo: {
                            map: 'china',
                            label: {
                                emphasis: {
                                    show: false,
                                },
                            },
                            roam: false,
                            itemStyle: {
                                normal: {
                                    areaColor: '#FCCE10',
                                },
                            },
                        },
                        series: [
                            {
                                name: '中国',
                                type: 'scatter',
                                coordinateSystem: 'geo',
                                animation: false,
                                blurSize: 50,
                                data: data,
                            },
                        ],
                    };
                    if ($scope.status.hasPicture) {
                        var myChart = echarts.init(document.getElementsByClassName('detail_content_picture')[0]);
                        myChart.setOption(option);
                        window.onresize = myChart.resize;
                        // var img = new Image();
                        var img = myChart.getDataURL({
                            type: 'png',
                            pixelRatio: 1,
                        });
                        getImage(nid, img);
                    }
                });
            });
        }

        /**
         * [typhoonChart description] 加载台风新闻的图片
         * @param  {[type]} nid [description]
         * @return {[type]}     [description]
         */
        function typhoonChart(nid) {
            var params = {
                typeid: 'zyzx',
                serviceid: 'robotNews',
                modelid: 'typhoon',
                nid: nid,
            };
            require(['echarts', './lib/echarts/dist/echarts.min', './lib/echarts/map/js/world.js'], function(echarts) {
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post').then(function(data) {
                    if (data == null || data == '') {
                        $scope.status.hasPicture = false;
                        return;
                    }
                    $scope.status.isTyphoon = true;
                    var map_data = data[0].points.map(function(element, index) {
                        return [element.longitude, element.latitude];
                    });
                    var option = {
                        // title: {
                        //     text: '台风轨迹',
                        //     left: 'center',
                        //     textStyle: {
                        //         color: 'black'
                        //     },
                        //     subtext: '(此图仅供浏览，不能被取稿)',
                        //     subtextStyle: {
                        //         color: 'red',
                        //         fontSize: 14
                        //     }
                        // },
                        tooltip: {
                            trigger: 'item',
                        },
                        toolbox: {
                            show: true,
                            feature: {
                                dataZoom: {
                                    yAxisIndex: 'none',
                                },
                                dataView: { readOnly: false },
                                magicType: { type: ['line', 'bar'] },
                                restore: {},
                                saveAsImage: {},
                            },
                        },
                        geo: {
                            // top: 120,
                            map: 'world',
                            roam: true,
                            center: [114.3896, 30.6628],
                            zoom: 4,
                            nameMap: {
                                China: '中国',
                            },
                            label: {
                                normal: {
                                    show: true,
                                },
                                emphasis: {
                                    show: true,
                                },
                            },
                            regions: [
                                {
                                    name: '中国',
                                    itemStyle: {
                                        normal: {
                                            areaColor: '#FFE680',
                                            borderColor: '#404a59',
                                        },
                                        emphasis: {
                                            areaColor: '#2a333d',
                                        },
                                    },
                                },
                            ],
                        },
                        series: [
                            {
                                name: '台风轨迹',
                                type: 'lines',
                                polyline: true, // 连续坐标
                                zlevel: 1,
                                effect: {
                                    show: true,
                                    constantSpeed: 80,
                                    symbol: 'circle',
                                    symbolSize: 5,
                                    color: 'red',
                                    trailLength: 0.7,
                                },
                                lineStyle: {
                                    normal: {
                                        color: '#a6c84c',
                                        width: 0,
                                        curveness: 0.2,
                                    },
                                },
                                data: [{ coords: map_data }],
                                animation: true,
                            },
                            {
                                type: 'effectScatter',
                                coordinateSystem: 'geo',
                                zlevel: 2,
                                rippleEffect: {
                                    brushType: 'stroke',
                                },
                                label: {
                                    normal: {
                                        show: true,
                                        position: 'right',
                                        formatter: '{b}',
                                    },
                                },
                                symbolSize: 5,
                                itemStyle: {
                                    normal: {
                                        color: '#0066B2',
                                    },
                                },
                                data: [
                                    { name: '北京', value: [116.4551, 40.2539] },
                                    { name: '上海', value: [121.4648, 31.2891] },
                                    { name: '广州', value: [113.5107, 23.2196] },
                                    { name: '深圳', value: [114.5435, 22.5439] },
                                    { name: '南宁', value: [108.479, 23.1152] },
                                    { name: '海口', value: [110.3893, 19.8516] },
                                    { name: '福州', value: [119.4543, 25.9222] },
                                    { name: '厦门', value: [118.1689, 24.6478] },
                                    { name: '南昌', value: [116.0046, 28.6633] },
                                    { name: '长沙', value: [113.0823, 28.2568] },
                                    { name: '武汉', value: [114.3896, 30.6628] },
                                    { name: '杭州', value: [119.5313, 29.8773] },
                                    { name: '温州', value: [120.498, 27.8119] },
                                    { name: '台北', value: [121.5365, 25.0192] },
                                ],
                            },
                        ],
                    };
                    if ($scope.status.hasPicture) {
                        var myChart = echarts.init(document.getElementsByClassName('detail_content_picture')[0]);
                        myChart.setOption(option);
                    }
                });
            });
        }

        /**
         * [getImage description] 图片上传服务
         * @param  {[type]} nid [description]
         * @param  {[type]} img [description]
         * @return {[type]}     [description]
         */
        function getImage(nid, img) {
            var params = {
                typeid: 'zyzx',
                serviceid: 'robotNews',
                modelid: 'image',
                nid: nid,
                image: img,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, 'post');
        }

        /**
         * [initQqjccInfos description] 初始化取签见撤重信息
         * @return {[type]} [description]
         */
        function initQqjccInfos() {
            getQqjccChannel();
            getQqjccInfo();
        }

        /**
         * [getQqjccChannel description] 获取取签见撤重媒体
         * @return {[type]} [description]
         */
        function getQqjccChannel() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'queryOperMediasList',
                guid: $stateParams.guid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.groupProcess.medias = [
                    {
                        MEDIANAME: '全部',
                        MEDIATYPE: '',
                        MEDIAID: '',
                    },
                ].concat(data);
                $scope.data.groupProcess.selectedMedia = $scope.data.groupProcess.medias[0];
            });
        }

        /**
         * [getQqjccInfo description] 获取取签见撤重信息
         * @return {[type]} [description]
         */
        function getQqjccInfo() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'queryOperFlagList',
                guid: $stateParams.guid,
                mediaid: $scope.data.groupProcess.selectedMedia.MEDIAID,
                mediatype: $scope.data.groupProcess.selectedMedia.MEDIATYPE,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.data.groupProcess.process = data.OPERS;
                if ($scope.data.groupProcess.process.length > 1) {
                    $('.resource_detail .groupProcess_process').css('height', ($scope.data.groupProcess.process.length - 1) * 120 + 'px');
                } else {
                    $('.resource_detail .groupProcess_process').css('height', '0px');
                }
            });
        }
        // 获取头像
        function headPortrait() {
            // detail
            var params = {
                serviceid: 'mlf_extuser',
                methodname: 'getUserHeadPic',
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.headPic = data.USERHEAD[0].PERPICURL == '' ? './images/user_icon.jpg' : data.USERHEAD[0].PERPICURL;
            });
        }
        $rootScope.$on('updateHeadPortrait', function(event, data) {
            headPortrait();
        });

        /**
         * [selectQqjccChannel description] 选择取签见撤重媒体
         * @param  {[type]} media [description] 当前媒体
         * @return {[type]}       [description]
         */
        $scope.selectQqjccChannel = function(media) {
            $scope.data.groupProcess.selectedMedia = media;
            getQqjccInfo();
        };

        /**
         * [pageTurning description] 翻页 上一篇/下一篇
         * @param {int} direction [description]
         * @return {[type]} [description]
         */
        $scope.pageTurning = function(direction) {
            var pageTurningData = JSON.parse(localStorageService.get('resourceDetail'));
            var toPageData;
            for (var i = 0; i < pageTurningData.length; i++) {
                if (pageTurningData[i].nid === $stateParams.guid) {
                    toPageData = pageTurningData[i + direction];
                    break;
                }
            }
            if (!toPageData) {
                var directionTxt = direction === 1 ? '下' : '上';
                modalDialog.alertType('没有' + directionTxt + '一篇了！', '', 'warning', false);
                return;
            }
            $state.go($state.current.name, {
                guid: toPageData.nid,
            }, {
                reload: true
            });
        };

        /**
         * [contentResize description] 设置左右侧高度一样
         * @return {[type]} [description]
         */
        $scope.contentResize = function() {
            $timeout(function() {
                var $father = $('.resource_detail');
                var $left = $father.find('.resource_detail_article');
                var $right = $father.find('.resource_detail_relatedInfo');
                var leftHeight = $left.height();
                $right.height(leftHeight);
                $left.resize(function(event) {
                    var leftHeight = $left.height();
                    $right.height(leftHeight);
                });
            });
        };

        /* 稿件操作开始*/
        /**
         * [collection description] 收藏
         * @return {[type]} [description]
         */
        $scope.collect = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'collect',
                guid: $stateParams.guid,
                channelName: 'jqrg',
                indexname: '',
                IsRobot: true,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('收藏成功!', '', 'success', false, '');
            });
        };

        /**
         * [creationAxis description] 个人素材
         * @return {[type]} [description]
         */
        $scope.creationAxis = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'batchPersonalMaterial',
                PersonalMaterialId: '0',
                guid: $stateParams.guid,
                channelName: 'jqrg',
                indexname: '',
                IsRobot: true,
            };
            $scope.loadingPromise = resourceCenterService.setBigDataCreation(params).then(function(data) {
                modalDialog.alertType('添加成功', '', 'success', false);
            });
        };

        /**
         * [takeDraft description] 取稿
         * @return {[type]} [description]
         */
        $scope.openTakeDraftModal = function() {
            var params = {
                serviceid: 'mlf_bigdataexchange',
                methodname: 'fetch',
                guid: $stateParams.guid,
                channelName: 'jqrg',
                indexname: '',
                IsRobot: true,
            };
            var modalInstance = resCtrModalService.fullTakeDraft(params, true, [$scope.detailInfos]);
            modalInstance.result.then(
                function(data) {
                    takeDraftDownloadImgs(data).then(function() {
                        storageListenerService.addListenerToResource('takeDraft');
                        initData();
                    });
                },
                function() {
                    storageListenerService.addListenerToResource('takeDraft');
                    initData();
                }
            );
        };

        /**
         * [takeDraftDownloadImgs description]  图片正在下载中情况，跳转至下载弹窗
         * @param  {[type]} data [description]
         * @return {[type]}      [description]
         */
        function takeDraftDownloadImgs(data) {
            var deferred = $q.defer();
            var needDownloadImg = false;
            for (var i = 0; i < data.REPORTS.length; i++) {
                if (data.REPORTS[i].PICERROR == 1) {
                    needDownloadImg = true;
                    break;
                }
            }
            if (needDownloadImg) {
                resCtrModalService.takeDraftDownloadImgs(data, function(res) {
                    deferred.resolve();
                });
            } else {
                deferred.resolve();
            }
            return deferred.promise;
        }

        /**
         * [print description] 打印
         * @return {[type]} [description]
         */
        $scope.printBtn = function() {
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, 'post').then(function(data) {
                trsPrintService.trsPrintRobot(data);
            });
        };

        /* 稿件操作结束*/
    },
]);
